import { ArrayField, TextField } from 'react-admin';
import { path } from '@/pages/AdverseAction/view/tables/RejectedReasonsTable/constants';
import { RejectedReasonsTableProps } from '@/pages/AdverseAction/view/tables/RejectedReasonsTable/types';
import { SecondaryDatagridStyled } from '@/styles/overrides';

const RejectedReasonsTable = ({ source }: RejectedReasonsTableProps) => {
  return (
    <ArrayField source={source}>
      <SecondaryDatagridStyled bulkActionButtons={false} rowClick={false}>
        <TextField source={path('reason')} label="" emptyText="-" sortable={false} />
      </SecondaryDatagridStyled>
    </ArrayField>
  );
};

export default RejectedReasonsTable;
